module.exports = __webpack_public_path__ + "da49e62905e66f6eae3e60746018ed1e.MP3";